import { Users as UsersIcon } from "@volt_developers/react-ui-components";

import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "../../../models/role/action";
import { SUBJECT_USER } from "../../../models/role/subject";
import { lazyRetry } from "../../../utils/lazyRetry";

import type { Route } from "../../../routes/RouteModel";

const UserList = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "UserManagementView" */
      "../pages/List"
    ),
  "UserManagementView"
);
const UserDetails = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "UserManagementView" */
      "../pages/Details"
    ),
  "UserManagementView"
);
const UserEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "UserManagementManage" */
      "../pages/Edit"
    ),
  "UserManagementManage"
);
const UserCreate = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "UserManagementManage" */
      "../pages/Create"
    ),
  "UserManagementManage"
);

export const userManagementRoutes: Route = {
  i18nName: "Users",
  icon: UsersIcon,
  path: "/configuration/users",
  component: UserList,
  newTheme: true,
  showChildrenInSidebar: false,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_USER,
  },
  children: [
    {
      path: "/configuration/users/create",
      i18nName: "Create user",
      component: UserCreate,
      newTheme: true,
      can: {
        do: ACTION_CREATE,
        on: SUBJECT_USER,
      },
    },
    {
      path: "/configuration/users/:id/edit",
      i18nName: "Edit user",
      component: UserEdit,
      newTheme: true,
      can: {
        do: ACTION_UPDATE,
        on: SUBJECT_USER,
      },
    },
    {
      path: "/configuration/users/:id",
      i18nName: "User",
      component: UserDetails,
      newTheme: true,
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_USER,
      },
    },
  ],
};
